/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { StyledDatePickerButton } from '#PRIVATE_StyledDatePickerButton';
import { UseDayCellProps, useDayCell } from './useDayCell';
import { dayCellStyles } from './themes/DayCellStyles.css';

type PickedUseDayCellProps = Pick<
  UseDayCellProps,
  | 'date'
  | 'dateFormatter'
  | 'dayFormatter'
  | 'isAdjacentMonth'
  | 'isDisabled'
  | 'isFocusable'
  | 'isFocused'
  | 'isHidden'
  | 'isReadonly'
  | 'isSelected'
  | 'isToday'
  | 'onAction'
  | 'onNavigation'
>;

type DayCellProps = PickedUseDayCellProps;

/**
 * The DayCell is the cell within the DatePicker's month view that contains the day in the month view.
 * This component will format the date for the aria-label.
 * The DayCell components uses the useDayCell hook to handle the user interactions with the day cell.
 */
export const DayCell = (props: DayCellProps) => {
  const { buttonProps } = useDayCell(props);
  // buttonProps, e.g., tabIndex, aria-label, onclick, onkeydown and visual states
  return (
    <div role="gridcell" class={dayCellStyles}>
      <StyledDatePickerButton {...buttonProps} />
    </div>
  );
};
